/* eslint-disable no-mixed-spaces-and-tabs */
import React, { Component } from 'react';
import * as yup from 'yup';
import moment from "moment-timezone";
import { Drawer, message, Popconfirm, Select } from "antd";
import { map, isEmpty, uniqBy, filter, orderBy, cloneDeep } from 'lodash';
import { StopOutlined, CloseOutlined, CloseCircleOutlined } from '@ant-design/icons';

import AddAddress from "../Common/AddAddress";
import UpdateGuest from "../Common/UpdateGuest";
import PrivateNotes from "../Common/PrivateNotes";
import UpdateContact from "../Common/UpdateContact";
import EmailRemainder from "../Common/EmailRemainder";
import UpdateBlockList from "../Common/UpdateBlockList";
import Loader from "../../../../Common/Component/Loader";
import AddAuthorizedUsers from "../Common/AddAuthorizedUsers";
import visa from '../../../../../Assets/images/visa_dark.svg';
import EmptyData from "../../../../Common/Component/EmptyData";
import american from '../../../../../Assets/images/american_express_dark.svg'
import {convertFirstCharToUppercase} from "../../../../../Tools/convertFirstLetterToUppercase";
import { aboutUsData } from "../../../../../Assets/data/aboutUsList";

const {Option} = Select;
const roles = [{key: 'Board Member', value: 'board_member'}, {key: 'Community Manager', value: 'community_manager'},
  {key: 'Concerned Resident', value: 'concerned_resident'}, {key: 'Billing', value: 'billing'}, {key: 'Management', value: 'management'}];
class AccountDetails extends Component {
  fattJs = null;
  
  constructor(props) {
    super(props);
    this.state = {
      customer: {},
      serviceOrder: {},
      loader: false,
      notifications: {},
      billing: {
        charge: false,
        printInvoice: false,
        emailInvoice: false
      },
      emailReminderModal: false,
      updateContact: false,
      addAuthorizedUser: false,
      showCreditCard: false,
      can_edit: false,
      blockList: {},
      cardList: {},
      cardDetail: {},
      pricingHistory: {},
      is_btn_active: false, // add/update credit card
      card_holder_name: '',
      card_address: {},
      showAddAddressView: false,
      addresses: [],
      updateGuest: false,
      updateBlockList: false,
      errors: {},
      deleteCardUuid: '',
      tech: '',
      tech_list: {},
      card_number : '',
      card_expiry_month : '',
      card_expiry_year : '',
      card_cvv : '',
      stax_customer_id : '',
      hideAddNewButton: false,
      BillingAddress: [],
      charge_invoices_to_card: true,
      default_card: ''
    }
  }

  componentDidMount = () => {
    const {
      getCommercialCustomer,
      getBlockList,
      getCardList,
      customerId,
      fieldOffice,
      getPricingHistory,
      getFieldTechnicianList,
      getBillingAddress
    } = this.props;

    if (customerId) {
      this.setState({ loader: true });
      getCommercialCustomer(customerId) // get customer detail
      getBlockList({ user__uuid: customerId }) // get block list
      getCardList({ user__uuid: customerId }) // get card list
      getPricingHistory({ service_order__user__uuid: customerId }) // get pricing history
      getFieldTechnicianList({ field_office__uuid: fieldOffice}) // Get list of technician
      getBillingAddress(customerId)
    }
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    const {cardList, cardDetail, customer, serviceOrder, blockList, pricingHistory, deleteCardUuid, BillingAddress} = this.state;
    this.setState({ loader: false });
    // get customer info

    if (Object.keys(nextProps?.CommercialCustomer?.getCustomer).length > 0
      && JSON.stringify(nextProps?.CommercialCustomer?.getCustomer) !== JSON.stringify(customer)) {
      this.setState({ 
        customer: nextProps?.CommercialCustomer?.getCustomer, 
        tech: nextProps?.CommercialCustomer?.getCustomer?.preferred_technician?.uuid || '',
        stax_customer_id : nextProps?.CommercialCustomer?.getCustomer?.stax_customer,
        stax_public_apikey: nextProps?.CommercialCustomer?.getCustomer?.field_office?.stax_public_apikey,
        hideAddNewButton: nextProps?.CommercialCustomer?.getCustomer?.field_office?.stax_public_apikey ? false : true
      });
    }

    // get service order
    if (Object.keys(nextProps?.ServiceOrder?.data).length > 0
      && JSON.stringify(nextProps?.ServiceOrder?.data) !== JSON.stringify(serviceOrder)) {
      this.setState({ serviceOrder: nextProps?.ServiceOrder?.data });
    }

    // update card detail
    if (Object.keys(nextProps?.UpdateCard?.data).length > 0 && JSON.stringify(nextProps?.UpdateCard?.data) !== JSON.stringify(this.props.UpdateCard?.data)) {
      this.setState({ updateCard: nextProps?.UpdateCard?.data, loader: true });
      this.props.getCardList({user__uuid: this.props.customerId}) // get card list
      this.props.getBillingAddress(this.props.customerId);
      // message.success('Updated Successfully');
    }

    // delete card detail
    if (Object.keys(nextProps?.DeleteCard?.data).length > 0 && JSON.stringify(nextProps?.DeleteCard?.data?.uuid) === JSON.stringify(deleteCardUuid)) {
      this.setState({ loader: true, deleteCardUuid: '' });
      this.props.getCardList({user__uuid: this.props.customerId}) // get card list
      // message.success('Updated Successfully');
    }

    // get block list
    if (Object.keys(nextProps?.BlockList?.data).length > 0
      && JSON.stringify(nextProps?.BlockList?.data) !== JSON.stringify(blockList)) {
      this.setState({ blockList: nextProps?.BlockList?.data });
    }

    // get card list
    if (Object.keys(nextProps?.CardList?.data).length > 0 && JSON.stringify(nextProps?.CardList?.data) !== JSON.stringify(cardList)) {
      let default_cards = nextProps?.CardList?.data?.results?.filter((item) => item.charge_invoice_card === true);

      if(nextProps?.CardList?.data?.results?.length > 0 && default_cards.length > 0)
      {
        this.setState({
          loader: false ,
          cardList: nextProps?.CardList?.data, 
          default_card: default_cards[0].uuid
        });
      }

      else
      {
        this.setState({ cardList: nextProps?.CardList?.data, loader: false });
      }
    }

    // get pricing history
    if (Object.keys(nextProps?.PricingHistory?.data).length > 0
      && JSON.stringify(nextProps?.PricingHistory?.data) !== JSON.stringify(pricingHistory)) {
      this.setState({ pricingHistory: nextProps?.PricingHistory?.data });
    }

    // send email for cc expiry
    if (Object.keys(nextProps?.EmailReminder?.sendEmail).length > 0) {
      const idx = cardList?.results?.findIndex(obj => obj.uuid === cardDetail.uuid);
      if (idx > -1) {
        Object.assign(cardList?.results?.[idx], {email_reminder: [...cardList?.results?.[idx]?.email_reminder, nextProps?.EmailReminder?.sendEmail]});
        this.setState({cardList})
      }
    }

    // Get list of technician
    if (Object.keys(nextProps?.FieldTechnician?.technicianList).length > 0
      && JSON.stringify(nextProps?.FieldTechnician?.technicianList) !== JSON.stringify(this.state?.tech_list)) {
      this.setState({ tech_list: nextProps?.FieldTechnician?.technicianList });
    }

    // get billing address
    if (nextProps && nextProps?.BillingAddress &&  nextProps?.BillingAddress?.data && nextProps?.BillingAddress?.data?.data && Object.keys(nextProps?.BillingAddress?.data?.data).length > 0
      && JSON.stringify(nextProps?.BillingAddress?.data?.data) !== JSON.stringify(BillingAddress)) {
      this.setState({ BillingAddress: nextProps?.BillingAddress?.data?.data });
    }

    if (this.state.hideAddNewButton) {
      message.error('Error occur while loading stax. please contact to admin.', 500);
    }
  }

  // get logged in user
  getLoggedInUserRole = () => {
    let authUser = JSON.parse(localStorage.getItem('authUser'))
    const logged_in_user_role = authUser?.user?.user_roles?.map(x => x.name)
    const is_franchise_owner = logged_in_user_role?.includes('franchise_owner')
    const is_account_corporate = logged_in_user_role?.includes('accounting_corporate')
    const is_service_rep = logged_in_user_role?.includes('service_rep')
    const is_corporate = logged_in_user_role?.includes('admin')
    return {hide_delete_card: (is_franchise_owner || is_account_corporate || is_service_rep || is_corporate)}
  }

  // on update contact details
  onUpdateClick = () => {
    const {updateCommercialCustomer} = this.props;
    const {customer} = this.state;
    let isPrimaryExist = false;

    filter(customer?.phone_numbers, (obj) => {
      if (obj.primary) {
        isPrimaryExist = true
      }
    });

    if (!isPrimaryExist) {
      customer.phone_numbers[0].primary = true;
    }

    updateCommercialCustomer(customer?.uuid, {
      phone_numbers: customer?.phone_numbers,
      emailaddress_set: customer.emailaddress_set,
      guest_users_set: customer.guest_users
    });
  };

  // on billing value change
  onBillingOptionsChanged = (e, item) => {
    const { cardList } = this.state;
    const idx = cardList?.results?.findIndex(obj => obj.uuid === item.uuid);
    const value = e.target.checked;
    Object.assign(cardList.results[idx], { [e.target.name]: value })
    this.setState({ cardList }, () => {
      const {cardList} = this.state;
      const idx = cardList?.results?.findIndex(obj => obj.uuid === item.uuid);
      let res = cardList?.results;
      if (!res?.[idx]?.address?.geo_location) delete res?.[idx]?.address?.geo_location;
      this.props.updateCard({
        'user_uuid': this.props.customerId,
        'uuid': res?.[idx]?.uuid,
        'address': res?.[idx]?.address,
        'stripe_card_details': res?.[idx]?.stripe_card_details,
        'card_holder_name': res?.[idx]?.card_holder_name,
        'email_invoice': res?.[idx]?.email_invoice || false,
        'charge_invoice_card': res?.[idx]?.charge_invoice_card || false,
        'print_invoice_card': res?.[idx]?.print_invoice_card || false,
      })
    });
  };

  // format phone number
  formatPhoneNumber = (phone) => {
    if (!phone) return ''
    phone = phone?.replace(/\D/g, '');
    return phone?.substr(0, 3) + ' ' + phone?.substr(3, 3) + ' ' + phone?.substr(6);
  }

  //toggle email remainder modal
  toggleEmailRemainder = (value) => {
    this.setState({ emailReminderModal: value });
  };

  //toggle update contact
  toggleUpdateContact = (value) => {
    this.setState({ updateContact: value });
  };

  //toggle add authorized user
  toggleAddAuthorizedUser = (value) => {
    this.setState({ addAuthorizedUser: value });
  };

  //toggle credit card drawer
  toggleCreditCard = (value, can_edit = false) => {
    this.props.getCardList({ user__uuid: this.props.customerId }) // get card list
    this.setState({ showCreditCard: value, can_edit });
    const FattJs = window.FattJs;
    const { stax_public_apikey } = this.state;
    if (stax_public_apikey) {
      const fattJs = new FattJs(stax_public_apikey, {
        number: {
          id: "card-number",
          placeholder: "Card Number",
          style:
            "height: 35px; width: 100%; font-size: 15px; font-family: Helvetica Neue, Helvetica; color: #31325f; font-weight: 300;" // 35px is the height of my card-number div
        },
        cvv: {
          id: "card-cvv",
          placeholder: "CVV",
          style:
            "height: 35px; width: 100%; font-size: 15px; font-family: Helvetica Neue, Helvetica; color: #31325f; font-weight: 300;" // 35px is the height of my card-cvv div
        }
      });
      fattJs.showCardForm().then(handler => {
        console.log('form loaded',handler);
      }).catch(err => {
        console.log('error init form ' + err);
      });
      this.fattJs = fattJs;
    } else {
      message.error('Error occur while loading stax. please contact to admin.', 10);
    }
  };

  // toggle Update Block List
  toggleUpdateBlockList = (value) => {
    this.setState({ updateBlockList: value });
  }

  // on notification change
  onNotificationChange = (e, type) => {
    const { notificationList } = this.state;
    const idx = notificationList.findIndex(obj => obj.type === type);
    if (idx > -1) {
      notificationList[idx] = Object.assign(notificationList[idx], { [e.target.name]: e.target.checked });
      this.setState({ notificationList });
    }
  }

  // on primary SMS phone number changed
  onSMSPrimaryChanged = (item) => {
    const {customer} = this.state;
    map(customer?.phone_numbers, (obj) => obj.can_send_sms = false)
    const index = customer.phone_numbers.findIndex(obj => obj.phone === item.phone)
    customer.phone_numbers[index].can_send_sms = true
    this.setState({customer}, () => this.onUpdateClick())
  }

  onChangePrimaryEmail = (email, type) => {
    let { customer } = this.state;

    switch(type)
    {
    case 'billing':
      customer.guest_users.forEach((item, index) => {
        if(item.role === 'billing')
        {
          if(item.email === email && !customer.guest_users[index].primary)
            customer.guest_users[index].primary = true;
          else
            customer.guest_users[index].primary = false;
        }
      });
      break;
    case 'company':
      customer.guest_users.forEach((item, index) => {

        if(item.role === 'management')
        {
          if(item.email === email && !customer.guest_users[index].primary)
            customer.guest_users[index].primary = true;
          else
            customer.guest_users[index].primary = false;
        }
      });
      break;
    case 'community':
      customer.emailaddress_set.forEach((item, index) => {
            
        if(item.email === email && !customer.emailaddress_set[index].primary)
          customer.emailaddress_set[index].primary = true;
        else
          customer.emailaddress_set[index].primary = false;
      });
    }

    this.setState({customer}, () => this.onUpdateClick());
  }

  // on Clear
  onClear = () => {
    this.setState({
      card_address: {
        address: '',
        city: '',
        state: '',
        zip_code: ''
      },
      card_holder_name: '',
      addresses: [],
      showAddAddressView: false,
      errors: {}
    });
  };

  //on cancel
  onCancel = () => {
    this.toggleCreditCard(false);
    this.onClear();
  }

  // card validation
  validation = () => {
    const { card_holder_name, card_address, card_number, card_expiry_month, card_expiry_year, card_cvv } = this.state;
    setTimeout(() => {
      const cardSchema = yup.object().shape({
        card_number : this.fattJs.validNumber ? null : yup.string().nullable().required('Card Number is required'),
        card_expiry_month : yup.string().nullable().required('Card expire month is required'),
        card_expiry_year : yup.string().nullable().required('Card expire year is required').min(4, 'Card expire year is invalid.').max(4, 'Card expire year is invalid.'),
        card_cvv : this.fattJs.validCvv ? null : yup.string().nullable().required('Card CVC is required'),
        card_address: yup.object().shape({
          address: yup.string().required("Address is required"),
          state: yup.string().required("State is required"),
          city: yup.string().required("City is required"),
          zip_code: yup.string().required("Zipcode is required")
        }),
        card_holder_name: yup.string().required("Cardholder name is required"),
      })

      const cardData = { card_address, card_holder_name, card_number, card_expiry_month, card_expiry_year, card_cvv };
      cardSchema.validate(cardData, { abortEarly: false }).then(() => {
        this.setState({errors: {}, is_btn_active: true})
        this.addNewCard()
      }).catch((error) => {
        let err_data = {};
        map(error.inner, (item) => {err_data[item.path] = item.message});
        this.setState({errors: err_data, is_btn_active: false});
        message.error(`Valid ${err_data.card_number}. Valid ${err_data.card_cvv}`);
      });
    }, 500);
  }

  // Add New Card
  addNewCard = () => {
    const { card_address, card_holder_name, customer, card_number, card_expiry_month, card_expiry_year, charge_invoices_to_card } = this.state;
    const {customerId} = this.props;
    this.setState({
      loader : true
    });
    const token_obj = {
      address_1: card_address ? card_address.address : null,
      address_city: card_address ? card_address.city : null,
      address_state: card_address ? card_address.state : null,
      address_zip: card_address ? card_address.zip_code : null,
      month : card_expiry_month ? card_expiry_month : null,
      year : card_expiry_year ? card_expiry_year : null,
      card_number: card_number ? card_number : null,
      email: customer && customer.email ? customer.email : null,
      firstname: customer && customer.first_name ? customer.first_name : null,
      lastname: customer && customer.last_name ? customer.last_name : null,
      method: 'card',
      person_name: customer ? `${customer.first_name} ${customer.last_name}` : null,
      phone: this.state.card_phone,
      charge_invoice_card: charge_invoices_to_card
    }
    if (this.state.stax_customer_id) {
      token_obj['customer_id'] = this.state.stax_customer_id;
    }
    this.fattJs.tokenize(token_obj).then((res) => {
      if(this.state.stax_customer_id === null || this.state.stax_customer_id === '') {
        this.setState({
          stax_customer_id : res.customer_id
        });
      }
      delete card_address.uuid;
      Promise.all([
        this.props.addNewCard({
          'user_uuid': customerId,
          'address': card_address,
          'stripe_payment_method_dict': {},
          'stax_card_token' : res.id,
          'card_holder_name': card_holder_name,
          charge_invoice_card: charge_invoices_to_card,
        })
      ]).then(() => {
        this.onCancel();
      });
    }).catch((err) => {
      this.setState({ loader : false });
      map(err.fieldErrors, (item) => {
        message.error(item.message,10)
      })
      console.log("Error : ",err);
      message.error(err.message,10);
    });
  }

  // update validation
  updateValidate = () => {
    const { card_holder_name, card_address } = this.state;
    setTimeout(() => {
      const cardSchema = yup.object().shape({
        card_holder_name: yup.string().required("Cardholder name is required"),
        card_address: yup.object().shape({
          address: yup.string().required("Address is required"),
          state: yup.string().required("State is required"),
          city: yup.string().required("City is required"),
          zip_code: yup.string().required("Zipcode is required")
        })
      });
      const cardData = { card_address, card_holder_name };
      cardSchema.validate(cardData, { abortEarly: false }).then(() => {
        this.setState({errors: {}, is_btn_active: true})
        this.onUpdateCard()
      }).catch((error) => {
        let err_data = {};
        map(error.inner, (item) => {
          message.error(item.message,10);
          err_data[item.path] = item.message
        })
        console.error("Error : ",err_data);
        this.setState({errors: err_data, is_btn_active: false});
        message.error(`Valid ${err_data.card_number}. Valid ${err_data.card_cvv}`);
      });
    }, 500);
  }

  // toggle add address view
  toggleAddAddress = (value) => {
    this.setState({showAddAddressView: value})
  }

  // on add address
  onAddAddress = (obj) => {
    const {addresses} = this.state;
    addresses.push({uuid: (Math.random() * 10).toString(), ...obj});
    this.setState({addresses});
  }

  // Update card
  onUpdateCard = () => {
    const {customerId} = this.props;
    const { card_holder_name, card_address, cardDetail, charge_invoices_to_card } = this.state;
    this.setState({ loader: true })
    if (card_address.uuid.includes('.')) delete card_address.uuid;
    if (!card_address.geo_location) delete card_address.geo_location;
    this.props.updateCard({
      'user_uuid': customerId,
      'uuid': cardDetail?.uuid,
      'address': card_address,
      'stripe_card_details': cardDetail?.stripe_card_details,
      'card_holder_name': card_holder_name,
      'charge_invoice_card': charge_invoices_to_card
    })
    this.props.getBillingAddress(customerId);
    this.toggleCreditCard(false);
    this.onClear();
  }

  //Set service Address
  serviceAddressCheck = (e, item) => {
    let { card_address } = this.state;
    if (e.target.checked) {
      card_address = cloneDeep({
        "uuid": item.uuid,
        "address": item.address,
        "city": item.city,
        "state": item.state,
        "zip_code": item.zip_code,
      })
      this.setState({
        card_address
      })
    }
  }

  isChecked = (item1, item2) => {
    if(item1?.address === item2?.address && item1?.address2 === item2?.address2 && item1?.city === item2?.city && item1?.state === item2?.state && item1?.zip_code === item2?.zip_code) {
      return true;
    }
    return false;
  }
  //render service address
  renderServiceOrder = () => {
    const { serviceOrder, addresses, card_address, cardList, BillingAddress, cardDetail,address } = this.state;

    let updatedCardList =  cardList?.results.filter(( obj ) =>{ 
      if (obj?.address?.formatted_address === card_address.formatted_address && cardDetail?.uuid === obj.uuid){
        return obj;
      }else if(obj?.address?.formatted_address !== card_address.formatted_address && cardDetail?.uuid !== obj.uuid){
        return obj;
      }
    });
    let updatedBillingAddress =  BillingAddress?.filter(( obj ) =>{ 
      if (obj?.formatted_address === card_address.formatted_address && cardDetail?.address?.uuid === obj.uuid){
        return obj;
      }else if(obj?.formatted_address !== card_address.formatted_address &&  cardDetail?.address?.uuid !== obj.uuid){
        return obj;
      }
    });
    const list = [...(updatedCardList?.map((each) => each.address) || []), ...(updatedBillingAddress || []), ...addresses];
    let addressList = [];
    //filter(list,(obj) => obj.is_billing_address_same ? addressList.push({...obj.service_address}) : obj.billing_address ? addressList.push({...obj.billing_address}) : addressList.push({...obj.address}));
    // addressList = uniqBy(orderBy([...list], 'uuid', 'desc'), 'uuid');

    addressList = uniqBy(
      orderBy([...list], "uuid", "desc"),
      "formatted_address"
    );
    if (addressList && addressList.length > 0) {
      addressList = addressList.filter((x) => {
        return x.uuid !== null;
      });
    }
    return map(addressList, (item, i) => {
      return (
        <div className="fitem-check" key={i}>
          <input
            type="radio" name="address"
            // checked={this.isChecked(card_address, item)}
            checked={card_address?.uuid === item.uuid}
            id={`address${i}`}
            className="fitem-ck-input"
            onChange={(e) => { this.serviceAddressCheck(e, cloneDeep(item)) }}
          />
          <label htmlFor={`address${i}`} className="fitem-ck-txt">
            {`${item.address}, ${item.city}, ${item.state}, ${item.zip_code} `}
          </label>
        </div>
      )
    })
  }

  // render primary info
  renderPrimaryInfo = () => {
    const {customer, tech, tech_list} = this.state;
    const { community_name } = customer;
    const phone_number = customer?.phone_numbers?.find((obj) => obj.primary === true)
    const community_manager = {user_name: `${customer?.first_name || ''} ${customer?.last_name || ''}`, phone_number: phone_number?.phone, email: customer?.email};
    const billing = customer?.guest_users?.filter(obj => obj.role === 'billing')[0] || {};
    const management = customer?.guest_users?.filter(obj => obj.role === 'management')[0] || {};

    return (
      <div className="card">
        <div className="card-title flex">
          <h5>Primary information</h5>
          {/* {customer?.is_active && <button className="btn btn-warning" onClick={(e) => {e.preventDefault(); this.props.deActivateCustomerConfirm() }}>Inactive</button>} */}
          {
              customer?.is_active ?
                <button className="btn btn-warning" onClick={(e) => {e.preventDefault(); this.props.deActivateCustomerConfirm() }}>Inactive</button> :
                <button className="btn btn-warning" onClick={(e) => {e.preventDefault(); this.props.activateCustomer() }}>Activate</button>
          }
        </div>
        <div className="card-body">
          {!isEmpty(community_manager) ?
            <div>
              <div className="flex flex-start mb-10">
                <div className="label">
                  <b>Community Manager:</b>
                </div>
                <div className="value">
                  <b>{community_manager?.user_name}</b>
                </div>
              </div>
              <div className="flex flex-start mb-10">
                <div className="label">
                  <b>Community Name:</b>
                </div>
                <div className="value">
                  <b>{community_name}</b>
                </div>
              </div>

              {/* <div className="mb-10">{community_manager?.phone_number ? `+1 ${this.formatPhoneNumber(community_manager?.phone_number)} (Primary)` : ''}</div>
              <div>{community_manager?.email ? `${community_manager?.email} (Primary)` : ''}</div> */}

              {/* Added checkbox for value */}
              <div className="fitem inline-check-list">
                {/* Phone numbers */}
                {
                  map(orderBy(customer?.phone_numbers, 'primary', 'desc'), (item, index) => {
                    return (
                      <div className="fitem-check" key={`checkboxPhone${index}`}>
                        <input
                          type="checkbox"
                          className="fitem-ck-input"
                          id={`checkboxPhone${index}`}
                          name={`phone${index}`}
                          checked={item?.primary}
                          onChange={() => this.onPhonePrimaryChanged(item)}
                        />
                        <label htmlFor={`checkboxPhone${index}`} className="fitem-ck-txt">
                          {`+1 ${this.formatPhoneNumber(item?.phone)} ${item?.primary ? '(Primary)' : ''}`}
                        </label>
                      </div>
                    )
                  })
                }
                {/* SMS Phone numbers */}
                {
                  map(orderBy(customer?.phone_numbers || [], 'can_send_sms', 'desc'), (item, index) => {
                    if (item?.can_send_sms) {
                      return (
                        <div className="fitem-check" key={`checkboxSms${index}`}>
                          <input
                            type="checkbox"
                            className="fitem-ck-input"
                            id={`checkboxSms${index}`}
                            name={`Sms${index}`}
                            checked={item?.can_send_sms}
                            onChange={() => this.onSMSPrimaryChanged(item)}
                          />
                          <label htmlFor={`checkboxSms${index}`} className="fitem-ck-txt">
                            {`+1 ${this.formatPhoneNumber(item?.phone)} ${item?.can_send_sms ? '(Primary SMS)' : ''}`}
                          </label>
                        </div>
                      )
                    }
                  })
                }
                {/* Emails */}
                {!customer?.is_dummy_email &&
              map(orderBy([...(customer?.emailaddress_set || [])], 'primary', 'desc'), (item, index) =>
              item?.email && !item.email.includes('doody.com') ?
                <div className="fitem-check" key={`communityEmail${index}`}>
                  <input
                    type="checkbox"
                    className="fitem-ck-input"
                    id={`communityEmail${index}`}
                    name={`communityEmail${index}`}
                    checked={item?.primary}
                    onChange={() => this.onChangePrimaryEmail(item.email, 'community')}
                  />
                  <label htmlFor={`communityEmail${index}`} className="fitem-ck-txt text-lowercase">
                    {`${item?.email} ${item?.primary ? '(Primary)' : ''}`}
                  </label>
                </div> : null
              )
                }
              </div>
            </div> : ''
          }
          {!isEmpty(billing) ?
            <div className='mt-20'>
              <div className="flex flex-start mb-10">
                <div className="label">
                  <b>Billing:</b>
                </div>
                <div className="value">
                  <b>{billing?.user_name ? billing?.user_name : ''}</b>
                </div>
              </div>
              <div className="mb-10">{billing?.phone_number ? `+1 ${this.formatPhoneNumber(billing?.phone_number)} (Primary)` : ''}</div>
              {/* <div>{billing?.email ? `${billing?.email} (Primary)` : ''}</div> */}
              {
                map(orderBy([...(customer?.guest_users.filter(item => item.role === 'billing') || [])], 'primary', 'desc'), (item, index) =>
                item?.email && !item.email.includes('doody.com') ?
                  <div className="fitem-check" key={`billingEmail${index}`}>
                    <input
                      type="checkbox"
                      className="fitem-ck-input"
                      id={`billingEmail${index}`}
                      name={`billingEmail${index}`}
                      checked={item?.primary}
                      onChange={() => this.onChangePrimaryEmail(item.email, 'billing')}
                    />
                    <label htmlFor={`billingEmail${index}`} className="fitem-ck-txt text-lowercase">
                      {`${item?.email} ${item?.primary ? '(Primary)' : ''}`}
                    </label>
                  </div> : null 
                )
              }
              <div>{billing?.address ? `${billing?.address?.address}` : ''}</div>
              <div>{billing?.address ? `, ${billing?.address?.city}, ${billing?.address?.city}, ${billing?.address?.city}` : ''}</div>
            </div> : ''
          }
          {!isEmpty(management) ?
            <div className='mt-20'>
              <div className="flex flex-start mb-10">
                <div className="label">
                  <b>Management:</b>
                </div>
                <div className="value">
                  <b>{ `${management.user_name ? management?.user_name : ''} ${management?.point_of_contact ? `, ${management?.point_of_contact}` : ''}`}</b>
                </div>
              </div>
              <div className="mb-10">{management?.phone_number ? `+1 ${this.formatPhoneNumber(management?.phone_number)} (Primary)` : ''}</div>
              {/* <div>{management?.email ? `${management?.email} (Primary)` : ''}</div> */}
              {
                map(orderBy([...(customer?.guest_users.filter(item => item.role === 'management') || [])], 'primary', 'desc'), (item, index) =>
                item?.email && !item.email.includes('doody.com') ?
                  <div className="fitem-check" key={`companyEmail${index}`}>
                    <input
                      type="checkbox"
                      className="fitem-ck-input"
                      id={`companyEmail${index}`}
                      name={`companyEmail${index}`}
                      checked={item?.primary}
                      onChange={() => this.onChangePrimaryEmail(item.email, 'company')}
                    />
                    <label htmlFor={`companyEmail${index}`} className="fitem-ck-txt text-lowercase">
                      {`${item?.email} ${item?.primary ? '(Primary)' : ''}`}
                    </label>
                  </div> : null 
                )
              }
            </div> : ''
          }
          <div className='mt-10'>
            <a href={'/#'} onClick={(e) => { e.preventDefault(); this.toggleUpdateContact(true) }}><u>Update Contact Details</u></a>
          </div>
        </div>
        <div className="card-body">
          <hr/>
          <div className={"card-label"}><b>Guest Users</b></div>
          {
            map(customer?.guest_users, (obj, index) => {
              if (obj.role !== 'community_manager' && obj.role !== 'billing' && obj.role !== 'management') {
                const role = roles.filter(x => x.value === obj.role)
                return (
                  <div key={`guest${index}`}>
                    <div className="flex flex-start mt-10">
                      <div><b>{obj?.user_name ? obj?.user_name : ''}</b> {role?.length > 0 ? role?.[0]?.key : ''}</div>
                    </div>
                    <div className='mt-10'>{obj?.email ? `${obj?.email}` : ''}</div>
                  </div>
                )
              }
            })
          }
          <div className='mt-10'>
            <a href={'/#'} onClick={(e) => { e.preventDefault(); this.toggleUpdateGuest(true) }}><u>Update Guest Users</u></a>
          </div>
        </div>
      </div>
    )
  };

  // render Billing Preference
  renderBilling = () => {
    const { cardList, default_card } = this.state;
    const {hide_delete_card} = this.getLoggedInUserRole()
    return (
      <div className="card order2">
        <div className="card-title flex">
          <h5>Billing Preferences</h5>
          <div>
            { cardList?.results?.length < 3 ? <button
              className="btn btn-warning"
              onClick={() => {
                this.setState({ cardDetail: {} })
                this.toggleCreditCard(true)
              }}
            >Add New</button> : <span />}
          </div>
        </div>
        <div className="card-body">
          {cardList?.results?.length > 0 ?
            map(orderBy(cardList?.results, 'uuid','asc'), (item, index) => {
              const expDate = `${JSON.parse(item.stax_payment_object).card_exp.toString().slice(0,2)}/${JSON.parse(item.stax_payment_object).card_exp.toString().slice(2,6)}`;
              const diff = moment(expDate).diff(moment(), 'days');
              const displayDiff = moment(expDate).fromNow();
              const displayText = diff < 0 ? `expired for ${displayDiff}` : `is due to expire ${displayDiff}`;
              const renderDefault = (default_card === '' && index === 0) || default_card === item.uuid;

              return (
                    
                <React.Fragment key={`card${index}`}>
                  {hide_delete_card ? <div className={'flex flex-end mb-10'}>
                    <Popconfirm
                      title="Are you sure?"
                      onConfirm={() => {
                        this.setState({loader: true, deleteCardUuid: item?.uuid})
                        this.props.deleteCard({uuid: item?.uuid})
                      }}
                      okText="Yes"
                      cancelText="No"
                      overlayClassName={"popup-width"}
                    >
                      <CloseCircleOutlined className={'danger'}/>
                    </Popconfirm>
                  </div> : ''}
                  <div className="flex ai-center mb-10" key={`card${item?.uuid}`}>
                    <div className="card_img flex ai-center">
                      {JSON.parse(item.stax_payment_object).card_type === 'visa' ?
                        <img height="25" src={visa} alt="" /> :
                        <img height="25" src={american} alt="" />} &nbsp;&nbsp;
                      <label className="m-0">{!isEmpty(JSON.parse(item.stax_payment_object)) ? `${JSON.parse(item.stax_payment_object).card_type} ending in ${JSON.parse(item.stax_payment_object).card_last_four}` : ''}</label>
                    </div>

                    <button
                      className="btn btn-warning xs-btn"
                      onClick={() => {
                        this.setState({
                          cardDetail: item,
                          card_address: item?.address,
                          card_holder_name: item?.card_holder_name,
                          charge_invoices_to_card: item?.charge_invoice_card,
                        }, () => this.toggleCreditCard(true, true))
                      }}
                    >Update</button>
                  </div>
                  {renderDefault &&
                    <label className="m-0">Default payment method</label>
                  }
                  {renderDefault &&
                    <hr />
                  }
                  {
                    (diff <= 60) &&
                        <blockquote className="horiz">
                          <b>{`This customer’s credit card ${displayText}.`}</b>
                          <button className="btn btn-warning mt-10" onClick={() => {this.setState({cardDetail: item}); this.toggleEmailRemainder(true)}}>Send Reminder Email</button>
                        </blockquote>
                  }
                </React.Fragment>
              )
            })
            : <EmptyData />
          }
        </div>
      </div>
    )
  }

  // render pricing history
  renderPricingHistory = () => {
    const { pricingHistory } = this.state;

    return (
      <div className="card order5">
        <div className="card-title">
          <h5>Pricing History</h5>
        </div>
        <div className="card-body">
          {pricingHistory?.results?.length > 0 ?
            map(pricingHistory?.results, (item, index) =>
              <div className="notes" key={`pricingHistory${index}`}>
                <span>{`Price Rise, activated ${moment(item?.preferred_start_date).format('MMM do YYYY')} May 1st 2019\n\nIncrease from $${item?.service_order?.calculated_price?.total_price_per_service} per service to $${item?.service_order?.calculated_price?.total_price_per_service}`}</span>
                <small>{`Accepted by client, ${item?.accepted_by?.first_name} ${item?.accepted_by?.last_name} ${moment(item?.preferred_start_date).format('MMM do YYYY')}\n\nProcessed manually by ${item?.processed_by?.first_name} ${item?.processed_by?.last_name}.`}</small>
              </div>
            ) : <EmptyData />
          }
        </div>
      </div>
    )
  };

  // render hear about us
  renderHearAbout = () => {
    const { customer } = this.state;
    const { hearAboutUs, outreach, channel_attribution } = this.props;
    const formatted_attribution = channel_attribution && channel_attribution.name !== 'Unknown' ?  convertFirstCharToUppercase(channel_attribution.name)  : '-';
    const hear_about_us = hearAboutUs ? hearAboutUs.map(item => convertFirstCharToUppercase(item)) : [];
    const formatted_outreach = outreach ?  convertFirstCharToUppercase(outreach.replace("_", " ")) : '-';

    return (
      <div className="card">
        <div className="card-title">
          <h5>Source & Attribution</h5>
        </div>
        <div className="card-body">
          <span>
            Outreach:<b style={{marginLeft: "5px"}}>{formatted_outreach}</b>
          </span><br/>
          <span>
            {`How did you hear about us:`} <b>{!isEmpty(hearAboutUs) ? `${aboutUsData.filter(item => hearAboutUs?.includes(item.value)).map(item2 => {return item2.name}).join(', ')}` : '-'}</b>
          </span><br/>
          <span>
            Attribution: <b style={{marginLeft: "5px", maxWidth: "none"}}>{formatted_attribution}</b>
          </span>
        </div>
      </div>
    )
  };

  // render block list
  renderBlockList = () => {
    const { blockList } = this.state;
    return (
      <div className="card">
        <div className="card-title flex">
          <h5>Block List</h5>
          <button className="btn btn-warning" onClick={() => this.toggleUpdateBlockList(true)}>Update</button>
        </div>
        <div className="card-body">
          {blockList?.results?.length > 0 ?
            map(blockList?.results, (item, index) =>
              <div className="blockedueser  flex flex-start mb-10" key={`block${index}`}>
                <div className="bico">
                  <StopOutlined />
                </div>
                <div className="btext">
                  <b className="d-block">{item?.blocked_user_details ? `${item?.blocked_user_details?.first_name} ${item?.blocked_user_details?.last_name} ${item?.blocked_user_details?.designation ? `, ${item?.blocked_user_details?.designation}` : ''}` : ''}</b>
                  <span>{`Reason: ${item?.reason}`}</span>
                </div>
              </div>
            ) : <EmptyData />
          }
        </div>
      </div>
    )
  };

  // render drawer
  renderCreditCardDrawer = () => {
    const {card_holder_name, showCreditCard, can_edit, showAddAddressView, errors, charge_invoices_to_card} = this.state;
    console.log(charge_invoices_to_card, "charge_invoices_to_card----969 comm")
    const closeDrawer = () => {this.toggleCreditCard(false); this.onClear()}
    return (
      <Drawer
        placement={'right'}
        closable={false}
        onClose={closeDrawer}
        visible={showCreditCard}
        key={'right'}
        width={'400'}
        className="drawer-wrapper"
      >
        <div className="rdrawer filter_drawer_wrapper">
          <div className="card-head flex ai-center">
            <h4>{can_edit ? 'Update Credit Card' : 'Add Credit Card'}</h4>
            <CloseOutlined onClick={closeDrawer}/>
          </div>

          <div className="card-row flex-column">
            <div className="card-full">
              <div className="form-group">
                {
                  !can_edit ?
                    <>
                      <div className="fitem">
                        <label>Card Number</label>
                        <div id="card-number" className="form--control"></div>
                      </div>
                      <div className="fitem">
                        <label>CVV</label>
                        <div id="card-cvv" className="form--control"></div>
                      </div>
                    </>
                    : ''
                }
                <div className="fitem">
                  <label>Cardholder Name</label>
                  <input
                    type="text"
                    value={card_holder_name || ''}
                    onChange={(e) => {
                      this.setState({card_holder_name: e.target.value});
                    }} className="form--control" placeholder="Cardholder Name" disabled={can_edit} />
                  {errors?.['card_holder_name'] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.['card_holder_name']}</label> : ''}
                </div>

                {!can_edit ?
                  <React.Fragment>
                    <div className="fitem half-fitem">
                      <div className="fitem half-fitem">
                        <label>Expiration Month</label>
                        <input type="text" className="form--control" placeholder="MM" maxLength={2} 
                          inputMode="numeric"
                          onPaste={(event) => {
                            if (event.clipboardData.getData('Text').match(/[^\d]/)) {
                              event.preventDefault();
                            }
                          }}
                          onKeyPress={(e) => {
                            const pattern = /[0-9]/;
                            const inputChar = String.fromCharCode(e.charCode);
                            if (!pattern.test(inputChar)
                            ) {
                              // invalid character, prevent input
                              e.preventDefault();
                            }
                          }}
                          onChange={(e) => { this.setState({ card_expiry_month: e.target.value }) }} />
                        {errors?.['card_expiry_month'] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.['card_expiry_month']}</label> : ''}
                      </div>
                      <div className="fitem half-fitem">
                        <label>Expiration Year</label>
                        <input type="text" className="form--control" placeholder="YYYY" maxLength={4} 
                          inputMode="numeric"
                          onPaste={(event) => {
                            if (event.clipboardData.getData('Text').match(/[^\d]/)) {
                              event.preventDefault();
                            }
                          }}
                          onKeyPress={(e) => {
                            const pattern = /[0-9]/;
                            const inputChar = String.fromCharCode(e.charCode);
                            if (!pattern.test(inputChar)
                            ) {
                              // invalid character, prevent input
                              e.preventDefault();
                            }
                          }}
                          onChange={(e) => { this.setState({ card_expiry_year: e.target.value }) }} />
                        {errors?.['card_expiry_year'] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.['card_expiry_year']}</label> : ''}
                      </div>
                    </div>
                  </React.Fragment> : ''
                }

                <div className="fitem half-fitem" style={{marginTop: "20px"}}>
                  <div className="fitem half-fitem" style={{display: "flex", alignItems: "center"}}>
                    <span style={{color: "#6f6f6f", fontWeight: "bold"}}>Charge invoices to card</span>
                  </div>
                  <div className="fitem half-fitem" style={{display: "flex", justifyContent: "flex-end"}}>
                    <div className="can-toggle can-toggle--size-small">
                      <input
                        id="charge_invoices_to_card"
                        type="checkbox"
                        className="fitem-ck-input"
                        name={"charge_invoices_to_card"}
                        checked={!charge_invoices_to_card} 
                        onChange={(e) => {this.setState({charge_invoices_to_card: !e.target.checked})}} 
                      />
                      <label htmlFor="charge_invoices_to_card" className="fitem-ck-txt black">
                        <div 
                          className="can-toggle__switch"
                          data-unchecked="Yes"
                          data-checked="No"
                        />
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr/>
            <div className="card-full pt-0">
              <div className="">
                <div className="mr-2 flex">
                  <b>Billing Address</b>
                  <a href="/#" className="action_link primary" onClick={(e) => { e.preventDefault(); this.toggleAddAddress(true)}}><b>Add New Address</b></a>
                </div>
                <div className="inline-check-list mt-10">
                  {this.renderServiceOrder()}
                  {(errors['card_address.address'] || errors['card_address.city'] || errors['card_address.state'] || errors['card_address.zip_code']) ?
                    <label className="new_err_msg"><i className="las la-info-circle"/>{'Billing address is required'}</label> : ''}
                  {showAddAddressView &&
                  <AddAddress
                    onCancel={this.toggleAddAddress}
                    onAdd={this.onAddAddress}
                  />}
                </div>

              </div>
            </div>
          </div>
          <div className="footer">
            <button className={`btn btn-bdr`} onClick={() => this.onCancel()}>Cancel</button>
            {can_edit ? <button
              className={`btn`}
              onClick={() => this.updateValidate()}>
              {'Update Card'}
            </button> : <button
              className={`btn`}
              onClick={() => this.validation()}>
              {'Add Card'}
            </button> }
          </div>
        </div>
      </Drawer>
    )
  };

  //toggle email remainder modal
  toggleLoader = (value) => {
    if (this.state.loader !== value) {
      this.setState({ loader: value });
    }
  };

  //toggle update guest user
  toggleUpdateGuest = (value) => {
    this.setState({ updateGuest: value });
  };

  render() {
    const {
      loader,
      emailReminderModal,
      customer,
      updateContact,
      addAuthorizedUser,
      cardDetail,
      showCreditCard,
      updateGuest,
      updateBlockList
    } = this.state;
    const { customerId } = this.props;

    return (
      <React.Fragment>
        <div className="block-row">
          <div className="card-row show-lg">
            {loader && <Loader />}
            <div className="card-col">
              {this.renderPrimaryInfo()}
              {this.renderHearAbout()}
              {this.renderBlockList()}
            </div>
            <div className="card-col">
              {this.renderBilling()}
              {this.renderPricingHistory()}
              <PrivateNotes
                customerId={this.props.customerId}
                getAccountNotes={this.props.getAccountNotes}
                addAccountNotes={this.props.addAccountNotes}
                AccountNotes={this.props.AccountNotes}
              />              
            </div>   
          </div>
          <div className="card-row hide-lg">
            {loader && <Loader />}
            <div className="card-col">
              {this.renderPrimaryInfo()}
              {this.renderBlockList()}
            </div>
            <div className="card-col">
              {this.renderBilling()}
              {this.renderPricingHistory()}
              {this.renderHearAbout()}
            </div>
            <div className="card-col">
              <PrivateNotes
                customerId={this.props.customerId}
                getAccountNotes={this.props.getAccountNotes}
                addAccountNotes={this.props.addAccountNotes}
                AccountNotes={this.props.AccountNotes}
              />
            </div>
          </div>
          {emailReminderModal && <EmailRemainder
            visible={emailReminderModal}
            customer={customer}
            cardDetail={cardDetail}
            emailReminder={this.props.EmailReminder}
            handleOk={(obj) => this.props.sendEmailReminder(obj)}
            handleCancel={() => this.toggleEmailRemainder(false)}
          />}
          {updateContact && <UpdateContact
            openDrawer={updateContact}
            customer={customer}
            customerId={this.props.customerId}
            closeDrawer={() => this.toggleUpdateContact(false)}
            // reducer
            CommercialCustomer={this.props.CommercialCustomer}
            NotificationList={this.props.NotificationList}
            // apis
            getCommercialCustomer={this.props.getCommercialCustomer}
            addGuestUser={this.props.addGuestUser}
            updateGuestUser={this.props.updateGuestUser}
            updateCommercialCustomer={this.props.updateCommercialCustomer}
            updateNotificationById={this.props.updateNotificationById}
            getNotificationById={this.props.getNotificationById}
            GoogleApi={this.props.GoogleApi}
            getGeocodeAddress={this.props.getGeocodeAddress} // api
            resetGeocodeAddress={this.props.resetGeocodeAddress} // api
          />}
          {updateGuest && <UpdateGuest
            openDrawer={updateGuest}
            toggleLoader={this.toggleLoader}
            CommercialCustomer={this.props.CommercialCustomer}
            getCommercialCustomer={this.props.getCommercialCustomer}
            customerId={this.props.customerId}
            closeDrawer={() => this.toggleUpdateGuest(false)}
            addGuestUser={this.props.addGuestUser}
            updateGuestUser={this.props.updateGuestUser}
            deleteGuestUser={this.props.deleteGuestUser}
          />}
          {updateBlockList && <UpdateBlockList
            openDrawer={updateBlockList}
            closeDrawer={() => this.toggleUpdateBlockList(false)}
            customerId={this.props.customerId}
            //APIs
            getBlockList={this.props.getBlockList}
            getUserList={this.props.getUserList}
            addBlockUser={this.props.addBlockUser}
            deleteBlockUser={this.props.deleteBlockUser}

            // reducers
            BlockList={this.props.BlockList}
            UserList={this.props.UserList}
          />}
          {addAuthorizedUser && <AddAuthorizedUsers
            openDrawer={addAuthorizedUser}
            customer={customer}
            customerId={customerId}
            updateCommercialCustomer={this.props.updateCommercialCustomer}
            authorizedUser={this.props.authorizedUser}
            getAuthorizedUserList={this.props.getAuthorizedUserList}
            addAuthorizedUser={this.props.addAuthorizedUser}
            deleteAuthorizedUser={this.props.deleteAuthorizedUser}
            closeDrawer={() => this.toggleAddAuthorizedUser(false)}
          />}
          {showCreditCard && this.renderCreditCardDrawer()}
        </div>
      </React.Fragment>
    );
  }
}

export default AccountDetails;
